import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import {
	AUTH_LOGIN,
	AUTH_REGISTER,
	AUTH_CREATE_PASSWORD,
	AUTH_RESET_PASSWORD
} from '../modules/authentication/utils/urls'

const Register = React.lazy(() => import('../modules/authentication/views/Register'))
const Login = React.lazy(() => import('../modules/authentication/views/Login'))
const ResetPassword = React.lazy(() => import('../modules/authentication/views/ResetPassword'))
const CreatePassword = React.lazy(() => import('../modules/authentication/views/CreatePassword'))

const GuestRoutes = () => {
	return (
		<Switch>
			<Route path={AUTH_REGISTER}>
				<Register />
			</Route>

			<Route path={AUTH_LOGIN}>
				<Login />
			</Route>

			<Route path={AUTH_RESET_PASSWORD}>
				<ResetPassword />
			</Route>

			<Route path={AUTH_CREATE_PASSWORD}>
				<CreatePassword />
			</Route>

			<Redirect to={AUTH_LOGIN} />
		</Switch>
	)
}

export default GuestRoutes
